import React from 'react';
import MisionVision from '../components/municipalidad/MisionVision';
import '../assets/styles/MunicipioLayout.scss';

const MisionVisionCont = () => (
  <div className='MainMunicipio'>
    <MisionVision />
  </div>
);
export default MisionVisionCont;
